import { useCallback, useRef } from 'react';

interface UseHoverHandlersDelayArg {
  onMouseOver: () => void;
  onMouseLeave: () => void;
  hideDelay?: number;
  showDelay?: number;
}

export const useHoverHandlersDelay = ({
  onMouseOver,
  onMouseLeave,
  hideDelay = 300,
  showDelay = 300,
}: UseHoverHandlersDelayArg) => {
  const hideTimer = useRef<NodeJS.Timeout>();
  const showTimer = useRef<NodeJS.Timeout>();

  const delayedHide = useCallback(() => {
    if (showTimer.current) clearTimeout(showTimer.current);
    hideTimer.current = setTimeout(onMouseLeave, hideDelay);
  }, [hideDelay, onMouseLeave]);

  const delayedShow = useCallback(() => {
    if (hideTimer.current) clearTimeout(hideTimer.current);
    showTimer.current = setTimeout(onMouseOver, showDelay);
  }, [onMouseOver, showDelay]);

  return {
    onMouseOver: delayedShow,
    onMouseLeave: delayedHide,
  };
};

export default useHoverHandlersDelay;
